export enum PAYMENT_TYPE {
  'No identificado',
  'PagoEfectivo',
  'Cuotéalo'
}
